export default {
    dashboard: "首页",
    currentPassword: "当前密码",
    password: "密码",
    confirmPassword: "确认密码",
    username: "用户名",
    firstName: "名字",
    lastName: "姓氏",
    name: "名称",
    contact: "联系号码",
    email: "邮件",
    description: "描述",
    companyName: "企业名称",
    company: "企业",
    address: "地址",
    address1: "地址#1",
    address2: "地址#2",
    country: "国家",
    state: "州属",
    area: "地区",
    postcode: "邮政编码",
    location: "仓库",
    toLocation: "目的地",
    supplier: "供应商",
    items: "物品",
    summary: "总结",
    destination: "目的地",
    repositoryNo: "货柜号",
    alternativeNo: "备用号",
    status: "状态",
    remark: "备注",
    type: "类型",
    updatePassword: "更新密码",
    branch: "分行",
    documentDate: "文件日期",
    documentNumber: "文件号",
    docNo: "文件号",
    dateTime: "日期时间",
    youHaveNotCreatedAnyItemYet: "目前还未添加任何项目.",
    youHaveNotSelectAnyItem: "您未选择任何项目",
    youHaveNotSelectAnyParentCategory: "目前还未选择任何上级类别.",
    previewPDF: "预览 PDF",

    weeklySales: "每周销售",
    newUsers: "新用户",
    itemOrders: "物品订单",
    bugReports: "漏洞报表",

    // ---------Page Title--------
    hiWelcomeBack: "欢迎回来, ",
    websiteVisits: "探访网址",
    administrators: "管理员",
    newAdministrator: "添加管理员",
    updateAdministrator: "更新管理员",
    customers: "客户",
    newCustomer: "添加客户",
    updateCustomer: "更新客户",
    suppliers: "供应商",
    newSupplier: "添加供应商",
    updateSupplier: "更新供应商",
    retailers: "零售",
    newRetailer: "添加零售",
    updateRetailer: "更新零售",
    drivers: "派送员",
    newDriver: "添加派送员",
    updateDriver: "更新派送员",
    workers: "仓库员",
    newWorker: "添加仓库员",
    updateWorker: "更新仓库员",
    products: "商品",
    newProduct: "添加商品",
    viewProduct: "查看商品",
    categories: "分类",
    newCategory: "添加分类",
    updateCategory: "更新分类",
    brands: "品牌",
    newBrand: "添加品牌",
    updateBrand: "更新品牌",
    uoms: "计量单位",
    newUom: "添加计量单位",
    updateUom: "更新计量单位",
    salesOrders: "销售订单",
    newSalesOrder: "添加销售订单",
    updateSalesOrder: "更新销售订单",
    viewSalesOrder: "查询销售订单",
    proformaSales: "形式销售",
    newProformaSales: "添加形式销售",
    updateProformaSales: "更新形式销售",
    viewProformaSales: "查询形式销售",
    salesInvoices: "销售发票",
    newSalesInvoice: "添加销售发票",
    updateSalesInvoice: "更新销售发票",
    deliveryOrders: "送货单",
    newDeliveryOrder: "添加送货单",
    updateDeliveryOrder: "更新送货单",
    verifyOut: "验证出货",
    verifyIn: "签收验证",
    verifyTransferIn: "验证转移进货",
    verifyTransferOut: "验证转移出货",
    cashSales: "现金销售",
    newCashSale: "添加现金销售",
    updateCashSale: "更新现金销售",
    salesDebitNotes: "销售借记单",
    newSalesDebitNote: "添加销售借记单",
    updateSalesDebitNote: "更新销售借记单",
    salesCreditNotes: "销售贷记单",
    newSalesCreditNote: "添加销售贷记单",
    updateSalesCreditNote: "更新销售贷记单",
    replacementDelivery: "替换交货",
    replacementDeliveries: "替换交货",
    newReplacementDelivery: "添加替换交货",
    updateReplacementDelivery: "更新替换交货",
    retailCashSales: "零售收银",
    newRetailCashSale: "添加零售收银",
    updateRetailCashSale: "更新零售收银",
    stockPost: "库存登记",

    purchaseOrders: "采购订单",
    newPurchaseOrder: "添加采购订单",
    updatePurchaseOrder: "更新采购订单",
    purchaseReturns: "采购退货",
    newPurchaseReturn: "添加采购退货",
    updatePurchaseReturn: "更新采购退货",
    purchaseInvoices: "采购发票",
    newPurchaseInvoice: "添加采购发票",
    updatePurchaseInvoice: "更新采购发票",

    itemReceives: "签收货物",
    newItemReceive: "添加签收货物",
    updateItemReceive: "更新签收货物",
    itemTransfers: "物品转移",
    newItemTransfer: "添加物品转移",
    updateItemTransfer: "更新物品转移",
    itemRelocates: "物品迁移",
    newItemRelocate: "添加物品迁移",
    updateItemRelocate: "更新物品迁移",
    itemTransforms: "物品转换",
    newItemTransform: "添加物品转换",
    updateItemTransform: "更新物品转换",
    itemIssues: "物品问题",
    newItemIssue: "添加物品问题",
    updateItemIssue: "更新物品问题",
    itemAdjustments: "物品调整",
    newItemAdjustment: "添加物品调整",
    updateItemAdjustment: "更新物品调整",
    stockTakes: "核对库存",
    newStockTake: "添加核对库存",
    updateStockTake: "更新核对库存",
    transferReturns: "调拨退货",
    newTransferReturn: "添加调拨退货",
    updateTransferReturn: "更新调拨退货",
    transferRequisitions: "调拨申请",
    newTransferRequisition: "添加调拨申请",
    updateTransferRequisition: "更新调拨申请",
    retailPrescriptions: "零售处方",
    newRetailPrescription: "添加零售处方",
    updateRetailPrescription: "更新零售处方",

    transporters: "运输公司",
    newTransporter: "添加运输公司",
    updateTransporter: "更新运输公司",
    tripOrders: "送货行程",
    newTrip: "添加送货行程",
    updateTrip: "更新送货行程",
    pickOrders: "拣货单",
    newPickOrder: "添加拣货单",
    updatePickOrder: "更新拣货单",
    containers: "货柜",
    newContainer: "添加货柜",
    updateContainer: "更新货柜",
    groupAdministrators: "后台管理员群",
    groupNewAdministrator: "添加后台管理员群",
    groupUpdateAdministrator: "更新后台管理员群",
    groupCustomers: "客户群",
    groupNewCustomer: "添加客户群",
    groupUpdateCustomer: "更新客户群",
    groupSuppliers: "供应商群",
    groupNewSupplier: "添加供应商群",
    groupUpdateSupplier: "更新供应商群",
    roles: "身份",
    newRole: "添加身份",
    updateRole: "更新身份",
    businesses: "企业",
    newBusiness: "添加企业",
    updateBusiness: "更新企业",
    locations: "仓库位置",
    newLocation: "添加仓库位置",
    updateLocation: "更新仓库位置",
    countries: "国家",
    updateCountry: "更新国家",
    injectionProps: "注入参数",
    newInjectionProp: "添加注入参数",
    shippingRates: "运费",
    newShippingRate: "添加运费",
    updateShippingRate: "更新运费",
    shippingRules: "运输规则",
    newShippingRule: "添加运输规则",
    updateShippingRule: "更新运输规则",

    customFields: "自定参数",
    newCustomField: "添加自定参数",
    updateCustomField: "更新自定参数",

    selectOnly1Location: "仅选择 1(个) 仓库",
    youHaveToSelectAnyoneOfTheWarehouseLocationToProceed: "必须选择一个仓库位置方能继续",

    // ------ Item -----
    model: "型号",
    itemName: "物品名称",
    price: "价格",
    unitPrice: "单价",
    length: "长",
    width: "宽",
    height: "高",
    weight: "重量",
    cbm: "立方",

    // ------ Listing ------
    createdAt: `创建时间`,
    createdBy: `创建账号`,
    createdDateTime: "创建时间",
    updatedAt: `更新时间`,
    updatedBy: `更新账号`,
    updatedDateTime: "更新时间",

    // ------ Button, Radio Button Action ------
    enabled: "启动",
    disabled: "关闭",
    remove: "删除",
    delete: "删除",
    cancel: "取消",
    confirm: "确认",
    approved: "已批准",
    back: "返回",
    paymentType: "付款类型",
    saveChanges: "保存",
    billing: "帐单地址",
    shipping: "收件地址",
    next: "下一步",
    new: "添加",
    createNew: "添加",
    add: "添加",
    search: "搜索",
    confirmSearch: "确认搜索",
    number: "序号",
    category: '类别',

    // ---------Search UI---------
    selectCustomer: "选择客户",
    selectSupplier: "选择供应商",
    selectMember: "选择会员",
    selectLocations: "选择仓库",
    searchCustomer: "搜索客户",
    searchAdministrator: "搜索管理员",
    searchSupplier: "搜索供应商",
    searchRetailMember: "搜索零售会员",
    searchMember: "搜索会员",
    searchItems: "搜索物品",
    searchKeyword: "搜索关键字",
    selected1Item: "已选择 (1) 个客户",
    searchDocuments: "搜索文件",
    selectContainer: "选择货柜",
    searchContainers: "搜索货柜",

    // -----------Permission---------
    manageItems: "管理物品",

    // ----------Identity Card UI & Update Profile---------
    credential: "凭证",
    accessAuthentication: "访问认证",
    profile: "档案",
    updateProfile: "更新档案",
    fullDetailsOfAdministratorInformation: "后台管理员的详细内容",
    locationPermissions: "位置权限",
    dataAccessScopes: "位置访问范围",
    changePassword: "更换密码",
    changeCredential: "更改凭证",
    verifyAccountOwnership: "验证账户所有权",

    // -----Custom Field-----
    customProperties: "自定义栏位",
    provideCustomItemInformation: "提供定制项目信息",
    properties: "属性",
    detailSettingsOfTheCustomField: "自定义参数详细设置",

    key: "关键",
    module: "模块",
    yes: "是",
    no: "否",
    function: "职能",
    label: "标签",
    nameLowercaseOnly: "名称 (仅小写)",
    displayLabel: "显示标签",
    functionType: "职能种类",
    moduleType: "模块种类",
    inputs: "输入",
    inputSettingsOfTheCustomField: "输入自定义参数的设置",
    inputType: "输入种类",
    basicSettings: "基础设定",
    advancedSettings: "高阶设定",
    customSettings: "其他设置",

    routeAdmin: `后台管理`,
    routeWorkstation: `仓库管理`,
    routeDriver: `物流管理`,
    routeCustomer: `用户`,
    routeRetail: `零售`,
    routeMember: `会员`,

    dateFilter: '日期筛选',
    fromDate: '从',
    toDate: '至',
    apply: '确认'

};